<template>
  <div class="ath-content clearfix" v-loading="loading">
    <div class="left">
      <img
        :src="flag ? authUrl : unauthUrl"
        :alt="flag ? '已授权' : '未授权'"
      />
      <span class="ath-status" :style="{ color: flag ? '#22BC02' : '#FD5801' }">{{
        flag
          ? dataStr[num].open.split(" ")[0]
          : dataStr[num].close.split(" ")[0]
      }}</span>
      <span>{{
        flag
          ? dataStr[num].open.split(" ")[1]
          : dataStr[num].close.split(" ")[1]
      }}</span>
      <div class="right" @click="gosq" v-if="checkAuth('authConfig')">
        <div>去设置 ></div>
      </div>
      <div class="rule" v-if="flag">
        <div class="ck-title">查看</div>
        <div class="rule-info" @click="followUpRule">跟进规则</div>
      </div>
    </div>
    
    <el-dialog
      custom-class="rule-dialog"
      title="跟进规则"
      :visible.sync="dialogVisible"
      width="25%">
      <div class="warning-info">
        <p class="title">待续费提醒：</p>
        <div class="body-info">应续日前30天电话提醒；应续日前1天电话提醒。</div>
      </div>
      <div class="warning-info">
        <p class="title">续费失败提醒：</p>
        <div class="body-info">应续日后第2天电话提醒续费失败原因。</div>
      </div>
      <div class="warning-info">
        <p class="title">宽限期提醒：</p>
        <div class="body-info">宽限期到期前10天电话提醒。</div>
      </div>
    </el-dialog>
    <el-dialog
    custom-class="rule-dialog"
      title="跟进规则"
      :visible.sync="disvisible"
      width="25%">
      <div class="warning-info">
        <p class="title">待续保提醒：</p>
        <div class="body-info">到期前30天电话提醒，若未联系上短信提醒。</div>
      </div>
      <div class="warning-info">
        <p class="title">续保失败提醒：</p>
        <div class="body-info">续保日后第2天电话提醒。</div>
      </div>
      <div class="warning-info">
        <p class="title">宽限期提醒：</p>
        <div class="body-info">根据每款产品的续保规则，可续保时间截止前3天电话提醒。</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  props: {
    num: Number,
    renewalType: String
  },
  data() {
    return {
      loading:false,
      authUrl: require("@static/images/order/orderD7.png"),
      unauthUrl: require("@static/images/order/orderD6.png"),
      mechanInfo: {},
      dataStr: [
        {
          open: "已授权凤栖云服跟进 凤栖云服顾问将以您的名义进行转化",
          close:
            "未授权凤栖云服跟进 凤栖云服顾问将不再直接联系客户，请留意客户预约信息并进行跟进",
        }, //预约订单
        {
          open:
            "已授权凤栖云服跟进 凤栖云服客服专员将以您的名义跟进客户保单续费情况",
          close:
            "未授权凤栖云服跟进 凤栖云服将不再直接联系客户，请留意客户保单续费情况",
        }, //续费管理
        {
          open: "已授权凤栖云服跟进 凤栖云服顾问将以您的名义进行转化",
          close:
            "未授权凤栖云服跟进 凤栖云服顾问将不再直接联系客户，请留意客户定制方案订单并进行跟进",
        }, //定制方案订单
        {
          open:
            "已授权凤栖云服跟进 凤栖云服专业续费团队将以您的名义跟进客户保单续保情况",
          close:
            "未授权凤栖云服跟进 凤栖云服将不再提醒客户续保，请您自行跟进客户续保情况",
        }, //续保管理
      ],
      flag: false,
      dialogVisible:false,
      disvisible:false
    };
  },
  created() {
    this.queryMechanConfig();
    this.mechanInfo = this.$tools.getLocal("userinfo");
  },
  mounted() {},
  methods: {
    queryMechanConfig: function () {
      var that = this;
      this.loading = true
      this.$http({
        url: "/master/mechan/queryMechanConfig",
        type: "put",
        params: {},
      }).then(function (data) {
        that.loading = false
        if (that.num == 0) {
          data.data.isFollow == 0 ? (that.flag = false) : (that.flag = true);
        } else if (that.num == 1 || that.num == 3) {
          data.data.isRenewalAuthorized == 0
            ? (that.flag = false)
            : (that.flag = true);
        } else if (that.num == 2) {
          data.data.paymentPlanAuthorized == "false"
            ? (that.flag = false)
            : (that.flag = true);
        }
      }).catch(e=>{that.loading = false});
    },
    gosq: function () {
      this.$router.push({
        path: "/setting/auth",
        query:{source:'1'} // 1其他页面
      });
    },
    followUpRule() {
      if(this.renewalType=='1'){
        this.disvisible=true
      }else if(this.renewalType=='2') {
        this.dialogVisible=true
      }
    },
  },
};
</script>
<style lang="scss">
.ath-content {
  line-height: 40px;
  padding: 10px 20px;
  font-size: 14px;
  background: #f7f7f7;
  margin-bottom: 10px;
  .ath-status{
    margin-right: 15px;
  }
  .left {
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      vertical-align: middle;
      color: #888888;
      letter-spacing: 1px;
    }
    img{
      margin-right: 8px;
      height: 34px;
      width: 34px;
    }
    .rule {
      display: inline-block;
      margin-left: 126px;
      letter-spacing: 1px;
      .ck-title,.rule-info{
        display: inline-block;
      }
      .rule-info {
        cursor: pointer;
        color: #ff9700;
        font-weight: 500;
      }
    }
  }
  .right {
    margin-left: 20px;
    display: inline-block;
    color: #ff9700;
    cursor: pointer;
    font-size: 14px;
    div {
      vertical-align: middle;
    }
  }
}
.warning-info{
  line-height: 20px;
  margin-bottom: 8px;
  letter-spacing: 1px;
  .title{
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    opacity: 1;
    &::before{
      width:8px;
      height: 8px;
      display: inline-block;
      content: '';
      border-radius:4px;
      background: #ff9700;
      margin-right: 6px;
    }
  }
  .body-info{
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #666666;
    font-size: 14px;
    margin-left: 14px;
  }
}

.rule-dialog{
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  .el-dialog__title{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .el-dialog__header{
    padding-bottom: 0px;
  }
  .el-dialog__body{
    padding: 4px 20px 30px 20px;
  }
}
</style>
